module.exports = __webpack_public_path__ + "static/media/mash.211aa296.png";